/* eslint-disable react/jsx-no-literals */
import React from 'react';

const RecordRevision = ({ revision }) => (
  <>
    {' '}
    [<span ui-ta="RecordRevision">{`${revision}`}</span>]
  </>
);

export default RecordRevision;
